// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"d2b80bc6","260":"a9d3e78e","310":"74337826","321":"35bf541c","350":"f1c2f288","529":"010fb0f6","682":"9c9d67c8","687":"8b493925","787":"1539df0d","825":"2eb976e2"}[chunkId] + ".chunk.js";
};